import React, { useEffect, useState } from 'react';
import './button.css';

const Button = ({
  text,
  action,
  disabled,
  color,
  classNames,
  padding,
  fill,
  textColor = "white", // ⚠️ Nueva prop con valor por defecto
}) => {
  const [colorState, setColorState] = useState("");
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    setColorState(disabled && color ? `${color}-light` : color);
  }, [color, disabled]);

  const handleClick = (event) => {
    if (action && !disabled) {
      event.preventDefault();
      action();
    }
  };

  const handleMouseEnter = () => {
    setColorState(!disabled && color ? `${color}-hard` : colorState);
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setColorState(disabled && color ? `${color}-light` : color);
    setIsHovered(false);
  };

  return (
    <button
      className={`fill-${fill
        ? colorState
        : !fill && isHovered
          ? colorState
          : `${disabled ? colorState : "White"}`
        } border-${!fill ? colorState : "none"} ${!padding ? "btn-general" : ""
        } ${"sorteo-button"} ${classNames}`}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      disabled={disabled}
    >
      <div className={`text-${textColor}`}>
        {text}
      </div>
    </button>
  );
};

export default Button;
